import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../Components/Button/Button'
import { useLocalization } from '../../../Hooks/useLocalization'
import './UserList.scss'
import { setDestinationView } from '../../../Store/InterfaceSlice'
import { TextInput } from '../../../Components/TextInput/TextInput'
import { type RootState } from '../../../Store/Store'
import { useEffect, useMemo, useState } from 'react'
import { TableList } from '../../../Components/TableList/TableList'
import {
  setIsCertificateInstancesRequested,
  setIsUsersRequested,
} from '../../../Store/DataSlice'
import { sortResultString } from '../../../Utils/Arrays'

const localizationSection = 'user-list'
export function UserList() {
  const dispatch = useDispatch()
  const localization = useLocalization(localizationSection)

  const isUsersRequested = useSelector(
    (state: RootState) => state.data.isUsersRequested
  )
  useEffect(() => {
    if (!isUsersRequested) dispatch(setIsUsersRequested(true))
  }, [isUsersRequested, dispatch])

  const isCertificateInstancesRequested = useSelector(
    (state: RootState) => state.data.isCertificateInstancesRequested
  )
  useEffect(() => {
    if (!isCertificateInstancesRequested)
      dispatch(setIsCertificateInstancesRequested(true))
  }, [isCertificateInstancesRequested, dispatch])

  const allCertificateInstances = useSelector(
    (state: RootState) => state.data.certificateInstances
  )

  const allUsers = useSelector((state: RootState) => state.data.users)
  const [filterEmail, setFilterEmail] = useState('')

  const filteredUsers = useMemo(() => {
    return allUsers
      .filter((c) => {
        if (
          filterEmail &&
          !c.email.toLowerCase().includes(filterEmail.toLowerCase())
        )
          return false
        return true
      })
      .sort((a, b) => sortResultString(a.email, b.email))
  }, [allUsers, filterEmail])

  return (
    <div className="users-list">
      <div className="button-row">
        <Button
          importance={'primary'}
          text={localization.text('add-user', 'Voeg gebruiker toe')}
          onClick={() =>
            dispatch(
              setDestinationView({
                destinationView: 'user-add',
              })
            )
          }
        />
      </div>
      <div className="filters">
        <div className="filter-field">
          <TextInput
            label={localization.text('filter-email-input-label', 'Email')}
            helperText={localization.text(
              'filter-email-input-helper',
              'Geef (een deel van) het email address van de gebruiker in'
            )}
            value={filterEmail}
            onChange={setFilterEmail}
          />
        </div>
      </div>
      <TableList
        tableType="user"
        items={filteredUsers}
        configurations={{
          email: {
            label: 'Email',
            show: true,
          },
          isAdmin: {
            label: 'Is administrator',
            show: true,
            getValue: (value) => ((value as boolean) ? '✔️' : '❌'),
          },
          certificateInstanceVatNumber: {
            label: 'Certificaat instantie',
            show: true,
            getValue: (value) =>
              allCertificateInstances.find((ci) => ci.vatNumber === value)
                ?.name ?? '',
          },
        }}
        localizationSection={localizationSection}
        getUniqueKey={(item) => item.email}
        onRowClick={(item) =>
          dispatch(
            setDestinationView({
              destinationView: 'user-detail',
              detailKey: item.email,
            })
          )
        }
        isLoading={allUsers.length === 0}
      />
    </div>
  )
}
